import { React, Component, Container, Config, _ } from "utils";
import { RatioStore, Creators } from "model";

export default class Ratio extends Component {
  componentDidMount() {
    this.zoom = CSS.supports("zoom: 0.5");

    this.timer = null;
    $(window).on("resize", this.handleResizeTimer);

    this.handleResize();
  }

  componentWillUnmount = () => {
    $(window).off("resize", this.handleResizeTimer);
  };

  handleResizeTimer = () => {
    clearTimeout(this.timer);
    this.timer = setTimeout(this.handleResize, 250);
  };

  handleResize = () => {
    var ratio = this.getRatio();
    Creators.ratioChanged(ratio);

    this.setState({ ratio: ratio });
  };

  getRatio() {
    var height = $(this.pavilion).height();
    return height / Config.params.MAX_HEIGHT;
  }

  setRef = (box) => {
    this.pavilion = box;
  };

  render = () => {
    var ratio = RatioStore.getRatio();
    var { children } = this.props;

    var css = ["ratio crop-box"];

    var style = {
      zoom: ratio,
    };

    let temp = Object.assign({}, children.props.data);
    if (temp.id && temp.stands.length === 1) {
      let standWidth = temp.stands[0].standType.standFeatureCount * 675 * ratio;
      let windowWidth = Math.max(
        document.documentElement.clientWidth,
        window.innerWidth || 0
      );
      if (windowWidth > standWidth) {
        let right = (windowWidth - standWidth) / 2;
        style = Object.assign(style, {
          position: "relative",
          left: right + "px",
        });
      }
    }

    if (this.zoom) css.push("zoom");
    else css.push("no-zoom");

    return (
      <div ref={this.setRef} className={css.join(" ")}>
        <div className="scale-box" style={style}>
          {children}
        </div>
      </div>
    );
  };
}



// WEBPACK FOOTER //
// ./src/modules/components/ratio.js